function ShortTextCell({text}) {
  
    return (
      <td>{text}</td>
    )
  }
  
  export default ShortTextCell